import React from "react";
import * as d3 from 'd3';
import PropTypes from "prop-types";
import "./blindMap.css"

const Marker = ({ d, x, y, type, size, selectedName, clickedName, onClick, mapType}) => {

    let color = "#B5C1E4"
    if (mapType === "GuessPoints") {
        if (clickedName) { // Click happened
            if (clickedName === d.name) { // If click was on me
                color = "#E25A14"
            }
            if (selectedName === d.name) {
                color = "#68DE21"
            }
        }
    } else if (mapType === "GuessNames") {
        if (selectedName === d.name) {
            color = "#68DE21"
        }
    }
    return (
        <g name={"Marker"}>
            <path
                className="Marker"
                d={d3.symbol().type(type).size(size)(d)}
                transform={`translate(${x},${y})`}
                fill={color}
                onClick={() => {
                    if (mapType === "GuessPoints") {
                        onClick(d.name)
                    }
                }}
                data-tip={d.name}
                data-for={d.name}
            />
        </g>
    )
}

Marker.propTypes = {
    type: PropTypes.object,
    size: PropTypes.number,
    color: PropTypes.string,
}

Marker.defaultProps = {
    type: d3.symbolTriangle,
    size: 100,
    color: "#9980FA"
}

export default Marker
